export enum NEW_TICKET_NOTIFICATION {
    EXPIRATION_TOOLTIP = 'expiration-tooltip',
    BALL_PUMP = 'ball-pump',
}